// One date formatter shared across Collections, Buddy collections, Feedback,
// and anywhere a plain "Jul 11, 2026" is wanted. NaN-guarded so a bad ISO
// string renders "" rather than "Invalid Date".
export function fmtDate(iso: string): string {
  const d = new Date(iso);
  return Number.isNaN(d.getTime())
    ? ""
    : d.toLocaleDateString(undefined, {
        year: "numeric",
        month: "short",
        day: "numeric",
      });
}
